$(document).ready(function(){
	$('#footer #botmenu>ul>li>p').click(function(){
		var activeLi=$(this).closest('li');
		activeLi.toggleClass('opened')
		$(this).closest('ul').children('li').each(function(i,li){
			console.log(i%2,li);
			if(i%2){
				if($(li).prev().is(activeLi)){
					$(li).toggleClass('opened');
				}
			}else{
				if($(li).next().is(activeLi)){
					$(li).toggleClass('opened');
				}
			}

		})
	})
})
